import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { QueryConfig } from '@/library/react-query';
import type { BaseResponse } from '@/types';

export type Bank = {
  accountHolderName: string;
  accountNumber: string;
  bankName: string;
  branchName: string;
  cancelledCheckLeaf: null;
  createdBy: string;
  createdDate: null;
  customer: null;
  digitalVerificationId: null;
  id: string;
  ifscCode: string;
  isVerified: null;
  lastModifiedBy: null;
  lastModifiedDate: null;
  ucic: null;
};

export type Vpa = {
  createdBy: string;
  createdDate: null;
  customerId: string;
  id: string;
  lastModifiedBy: null;
  lastModifiedDate: null;
  vpa: string;
};

export type BankDataResponseType = {
  bank: Bank[];
  vpa: Vpa[];
};

export const getBankInfo = async (
  id: string
): Promise<BaseResponse<BankDataResponseType>> => {
  return axios.get(`dg/customers/${id}/payment-details`);
};

type QueryFnType = typeof getBankInfo;
type UseGetBankInfo = {
  config?: QueryConfig<QueryFnType>;
  id: string;
};

export const useBankInfo = (data: UseGetBankInfo) => {
  const { id } = data; // config = {},
  return useQuery({
    queryKey: ['bankInfo'],
    queryFn: () => getBankInfo(id),
    enabled: !!id,
  });
};
